import { ChangeEvent } from "@mcleod/components";
import { AutogenLayoutOfficeBalanceForwardReport } from "./autogen/AutogenLayoutOfficeBalanceForwardReport";

export class OfficeBalanceForwardReport extends AutogenLayoutOfficeBalanceForwardReport {

    /** Event handler for Include Settlement checkbox change */
    checkboxIncludeSettlementOnChange(event: ChangeEvent): void {
        this.excludabletextboxPayee.textbox.clear();
        if(this.checkboxIncludeSettlement.checked) {
            this.excludabletextboxPayee.textbox.lookupModel = "lme/settlement/transfer-to-settlement-payee";
            this.excludabletextboxPayee.textbox.lookupModelLayout = "lme/settlement/TransferToSettlementPayeeLookup";
        }
        else {
            this.excludabletextboxPayee.textbox.lookupModel = "lme/settlement/officepayroll/off-payee";
            this.excludabletextboxPayee.textbox.lookupModelLayout = "lme/settlement/officepayroll/OfficePayeeLookup";
        }
        const includeSettlement = this.checkboxIncludeSettlement.checked;

        // Enable/disable the payee type textbox based on checkbox state
        this.textboxPayeeType.enabled = includeSettlement;

        // If unchecking, clear the payee type selection
        if (!includeSettlement) {
            this.textboxPayeeType.text = "";
        }
    }
}
